export default __webpack_public_path__ + "static/media/discovery.7baf483a.png";